import React from 'react';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <div className="space-y-2">
              <p className="flex items-center">
                <Phone size={20} className="mr-2" />
                +1 (555) 123-4567
              </p>
              <p className="flex items-center">
                <Mail size={20} className="mr-2" />
                info@BlueLakeEscapesFI.com
              </p>
              <p className="flex items-center">
                <MapPin size={20} className="mr-2" />
                123 Casino Drive, Toronto, ON
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-blue-300 transition-colors">
                <Facebook size={24} />
              </a>
              <a href="#" className="hover:text-blue-300 transition-colors">
                <Twitter size={24} />
              </a>
              <a href="#" className="hover:text-blue-300 transition-colors">
                <Instagram size={24} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Newsletter</h3>
            <form className="flex">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 p-2 rounded-l-lg text-gray-800"
              />
              <button
                type="submit"
                className="bg-blue-700 px-4 rounded-r-lg hover:bg-blue-800 transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-blue-800 text-center">
          <p>&copy; 2024 BlueLakeEscapesFI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}